export const COMPUTE_FOLDER_NEXT_STATES_STARTED = "COMPUTE_FOLDER_NEXT_STATES_STARTED";
